import {z} from 'zod';

export type TokenId = number;
export type Address = string;

export const NetworkSchema = z.enum(['polygon', 'polygon-mumbai', 'local']);
export type Network = z.infer<typeof NetworkSchema>;

export const BlockchainNameSchema = z.enum(['Local', 'Mumbai', 'Polygon']);
export type BlockchainNameDto = z.infer<typeof BlockchainNameSchema>;

export const TokenStandardSchema = z.enum(['ERC-1155']);
export type TokenStandardDto = z.infer<typeof TokenStandardSchema>;

export const TokenMetadataAttributeSchema = z.object({
  trait_type: z.string(),
  value: z.string(),
});
export type TokenMetadataAttributeDto = z.infer<typeof TokenMetadataAttributeSchema>;

export const TokenMetadataSchema = z.object({
  name: z.string(),
  description: z.string(),
  image: z.string().url(),
  animation_url: z.string().url().nullable(),
  external_url: z.string().url().optional(),
  attributes: z.array(TokenMetadataAttributeSchema),
});
export type TokenMetadataDto = z.infer<typeof TokenMetadataSchema>;

export const CollectionMetadataSchema = z.object({
  name: z.string(),
  image: z.string().url(),
  description: z.string(),
  external_link: z.string().url(),
});
export type CollectionMetadataDto = z.infer<typeof CollectionMetadataSchema>;
